import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as bootstrap from "bootstrap";
import * as $AB from 'jquery';
declare const func: any;

@Component({
  selector: 'app-sell',
  templateUrl: './sell.component.html',
  styleUrls: ['./sell.component.css']
})
export class SellComponent implements OnInit {
  

  filter_uploads:any;
  filter_transactions:any;
  filter_sales:any;

  constructor(private router: Router) { }

  ngOnInit(): void {
    var Router=this.router;
    let filter_class=this;
   func();
  
  $(document).ready(function(){
  $('.sell').addClass('active');
  $('.sell a').css('color','#fff');
   $('.sell img').attr('src','./assets/image/icon/Sell.png');
  });
   $('.item-card .card-bottom .termcondition').click(function(){
         Router.navigateByUrl('/termcondition');
  });
  $('.item-card .card-bottom .algotermcondition').click(function(){
         Router.navigateByUrl('/algotermcondition');
  });
  $('.item-card .card-bottom .enginetermcondition').click(function(){
         Router.navigateByUrl('/enginetermcondition');
  });
  $('.item-card .card-bottom .soltermcondition').click(function(){
         Router.navigateByUrl('/soltermcondition');
  });
  $(".filter_show").click(function(){
     $(".filter_analytics").removeClass("d-none").addClass("d-block");
    });
     $(document).mouseup(function(){
             $(".filter_analytics").removeClass("d-block").addClass("d-none");
        });

         $(document).ready(function(){
           $("input[name='filter_date']:checked").trigger("click");
        });

        $("input[name='filter_date']").click(function(){
        if($(this).prop('checked')==true){
        if($(this).val()==5){
         filter_class.filter_uploads=50;
         filter_class.filter_transactions=54;
         filter_class.filter_sales=100;
        }
        if($(this).val()==4){
         filter_class.filter_uploads=10;
         filter_class.filter_transactions=30;
         filter_class.filter_sales=30;
        }
        if($(this).val()==3){
         filter_class.filter_uploads=20;
         filter_class.filter_transactions=50;
         filter_class.filter_sales=70;
        }
        if($(this).val()==2){
         filter_class.filter_uploads=40;
         filter_class.filter_transactions=50;
         filter_class.filter_sales=90;
        }
        } 
    });  
  }


     hovercard(){
         $(".info_heading").css('transition','0.5s all'); 
         $(".inner-div").css('transition', '5.5s all');
       }
        hovercard2(){
          $(".info_heading").css('transition','0.65s all');
          $(".inner-div").css('transition', '0.5s all')
        }
         

        dataInfo(event){
           $(".dataInfo").modal('show');
         }
         algoInfo(event){
           $(".algoInfo").modal('show');
         }
         engineInfo(event){
           $(".engineInfo").modal('show');
         }
         solutionInfo(event){
           $(".solutionInfo").modal('show');
         }


       }
  

